import { Type } from '@warp-drive/core-types/symbols';
import ParityStrategyBreakdown from 'lumen/models/parity-strategy/breakdown';

export default class ParityStrategyPromotion extends ParityStrategyBreakdown {
  // @ts-expect-error: Class inheritance
  [Type] = 'parity-strategy/promotion' as const;

  modelName = 'parity-strategy/promotion';
}
